<template>
  <div v-if="topics && topics.length > 0">
    <div class="edit-interests-btn" @click="launchEditInterestsModal">
      Edit interests
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditInterestsModal from "./EditInterestsModal";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "edit-interests-button",
  props: ["topics"],
  mixins: [HomebaseMixpanelMixin],
  watch: {
    getStartedClicked(newVal) {
      if (newVal === true) this.launchEditInterestsModal();
    }
  },
  computed: {
    ...mapGetters(["getStartedClicked"])
  },
  methods: {

    launchEditInterestsModal() {
      this.trackNewsEditInterestsClick();
      this.$modal.show(
        EditInterestsModal,
        {
          topics: this.topics
        },
        {
          adaptive: true,
          scrollable: true,
          width: 900,
          height: "auto",
        },
        {
          interestsSaved: () => {
            this.handleInterestsSaved();
          },
        }
      );
    },

    handleInterestsSaved() {
      this.$parent.$emit("interestsSaved");
    },
  },
};
</script>

<style scoped>
.edit-interests-btn {
  font-family: artifaktElementBold;
  font-size: 16px;
  color: #000;
  text-decoration: underline;
}
.edit-interests-btn:hover {
  cursor: pointer;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/EditInterestsButton.vue